
<form [formGroup]="queryReportForm">
  <div class="row mb-2">
    <div class="col-md-12">
      <div>All fields are required.</div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-3">
      <div class="form-group"><label for="queryReportType">Query Report Type</label>
        <select formControlName="queryReportType"
                class="form-control required" aria-required="true" id="queryReportType" name="queryReportType" aria-label="query report type"
                (change)="updateValidators($event)"
                [ngClass]="{'is-invalid': formErrorHandler.hasError(queryReportForm ,'queryReportType', 'required')}"
                required="required" [attr.aria-invalid]="formErrorHandler.hasError(queryReportForm ,'queryReportType', 'required')">
          <option [value]="" [disabled]="true" [selected]="true">-- Select a Query Report Type --</option>
          <ng-container *ngIf="!profile.bulkDataReport">
            <option [value]="queryReportTypes.transactions.value" *appHasAnyAuthority="['MY_QUERY_REPORT', 'QUERY_REPORT']">{{queryReportTypes.transactions.text}}</option>
            <option [value]="queryReportTypes.species.value" *appHasAnyAuthority="['MY_QUERY_REPORT', 'QUERY_REPORT']">{{queryReportTypes.species.text}}</option>
          </ng-container>
          <option [value]="queryReportTypes.industry.value" *appHasAuthority="'INDUSTRY_REPORT'">{{queryReportTypes.industry.text}}</option>
        </select>
        <div *ngIf="formErrorHandler.hasError(queryReportForm ,'queryReportType', 'required')" role="alert" class="formError text-danger"
             aria-live="assertive">
          Required
        </div>
        <div *ngIf="isIndustry()" role="alert" class="formError text-warning" aria-live="assertive">
          The Industry Dealer Report Summary is automatically generated on the first of every month. Changes won’t appear until the next prompt date.
        </div>

      </div>
    </div>

    <div class="col-md-3">
      <div class="form-group">
        <app-month-input [id]="'queryFrom'"
                     [title]="'Query From'"
                     formControlName="queryFrom"
                     (itemSelect)="onQueryFromSelect($event)"
                     [isInvalid]="formErrorHandler.hasGroupError(queryReportForm, 'queryReportTimeframe') || formErrorHandler.hasError(queryReportForm ,'queryFrom')">

        </app-month-input>
        <div *ngIf="formErrorHandler.hasError(queryReportForm ,'queryFrom', 'dateRequired')" role="alert" class="formError text-danger"
             aria-live="assertive">
          Required
        </div>
        <div *ngIf="formErrorHandler.hasGroupError(queryReportForm, 'queryReportTimeframe')" role="alert" class="formError text-danger" aria-live="assertive">
          Please, enter a valid time frame.
        </div>

      </div>
    </div>

    <ng-container *appHasAnyAuthority="['MY_QUERY_REPORT', 'QUERY_REPORT']">
      <div class="col-md-3" *ngIf="!isIndustry()">
        <div class="form-group">

          <app-month-input [id]="'queryTo'"
                       [title]="'Query To'"
                       formControlName="queryTo"
                       (itemSelect)="onQueryToSelect($event)"
                       [isInvalid]="formErrorHandler.hasGroupError(queryReportForm, 'queryReportTimeframe') || formErrorHandler.hasError(queryReportForm ,'queryTo')">

          </app-month-input>
            <div *ngIf="formErrorHandler.hasError(queryReportForm ,'queryTo', 'dateRequired')" role="alert" class="formError text-danger" aria-live="assertive">
              Required
            </div>
            <div *ngIf="formErrorHandler.hasGroupError(queryReportForm, 'queryReportTimeframe')" role="alert" class="formError text-danger" aria-live="assertive">
              Please, enter a valid time frame.
            </div>
        </div>
      </div>

      <div class="col-md-3" *ngIf="!isIndustry()">
        <div class="form-group">
          <label for="reportType">Report Type</label>
          <select class="form-control required" aria-required="true" id="reportType" formControlName="reportType"
                  aria-label="report type"
                  [ngClass]="{'is-invalid': formErrorHandler.hasError(queryReportForm ,'reportType', 'required')}">
            <option [value]="" [disabled]="true" [selected]="true">-- Select a Report Type --</option>
            <option [value]="ReportType[ReportType.P]">{{ReportType.meaning(ReportType.P)}}</option>
            <option [value]="ReportType[ReportType.PAQ]">{{ReportType.meaning(ReportType.PAQ)}}</option>
          </select>
          <div *ngIf="formErrorHandler.hasError(queryReportForm ,'reportType', 'required')" role="alert" class="formError text-danger"
               aria-live="assertive">
            Required
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="row">

    <div class="col-md-3">
      <button class="btn btn-primary btn" (click)="onSubmit()" [disabled]="!queryReportForm.valid  && queryReportForm.pristine"><i class="fas fa-check">
      </i> Query Report
      </button>
    </div>

    <ng-container *appHasAuthority="'GENERATE_INDUSTRY_REPORT'">
      <div class="col-md-3" *ngIf="isIndustry() && appSettings.generateIndustryReportButtonEnabled">
        <button class="btn btn-primary btn" (click)="onGenerate()" [disabled]="!queryReportForm.valid && queryReportForm.pristine"><i class="fas fa-check">
        </i> Generate Industry Report
        </button>
      </div>
    </ng-container>

  </div>
</form>
